import { Product } from '@framework/types';
import { CartItem } from '@utils/generate-cart-item';
import { Item } from '@contexts/cart/cart.utils';

export const getProductImageUrl = (product: Product | CartItem | Item) => {
  return `https://storage.googleapis.com/danel-images/products/${product.image?.replace('\\', '/')}`;
};
